export function extractSystemMessage(str) {
	const regex = /@\[\[\[SYSTEM_MESSAGE\('([^']*)'\)\]\]\]@/;
	const match = str?.match(regex);
	return match?.[1] || '';
};